import { render, staticRenderFns } from "./NewsBoard.vue?vue&type=template&id=64955340&scoped=true&"
import script from "./NewsBoard.vue?vue&type=script&lang=ts&"
export * from "./NewsBoard.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoard.vue?vue&type=style&index=0&id=64955340&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64955340",
  null
  
)

export default component.exports